<template>
  <d-pageedit
    v-model="g"
    canadd
    title="Commercial models"
    :search="getsearch()"
    :params="params"
    :margintop="80"
    @clear="clear($event)"
    @load="load($event)"
    @del="del($event)"
    @save="save($event)"
  >
    <d-nav :pages="['main', 'json']" page="id0" class="px-5">
      <div slot="id0">
        <b-row>
          <div class="col-9">
            <b-row>
              <d-input v-model="g.des" label="Description" placeholder="Description" :cols="12" />
              <d-coddes v-if="g.refcod" v-model="g.refcod" label="related cModel"
                        :search="{ service:'cModelsData',params: {table:'CMODF', Catalogo: this.user.catalog || this.user.cats[0].cod}}"
                        :cols="12"
              />
              <d-input v-model="g.help" label="info" type="area" :cols="12" />
              <d-auth v-model="g.auth" label="Auth" :cols="12" admins users groups />
            </b-row>
          </div>
          <div class="col-3">
            <div class="px-3">
              <code>Upload Image</code>
              <d-upload type="gen" :newname="newname" dim="256x256" :image="g.logo" images height="250px"
                        @loaded="changeimg($event)"
              />
            </div>
          </div>
        </b-row>
        <b-row>
          <d-input v-model="g.isfinal" label="is final" type="check" :cols="1" />
          <d-input v-model="g.istop" label="Is Root" type="check" :cols="1" />
          <d-input v-model="g.ordine" label="Order" type="number" :cols="1" />
        </b-row>
        <div v-if="g.cod">
          <div v-if="!g.isfinal">
            <b-row full class="pt-2">
              <d-card title="Related models" expand closed>
                <d-table :rows="g.linkedmodels" height="200px" :columns="colfields" editable add>
                </d-table>
              </d-card>
            </b-row>
          </div>
          <div v-if="g.isfinal">
            <div class="row">
              <d-coddes v-model="g.basemodel" label="Base Model"
                        :search="{ service:'cModelsData',params: {table:'MOD', Catalogo: this.user.catalog || this.user.cats[0].cod}}"
              />
            </div>
            <b-row :no-gutters="true" full style="margin-top:40px">
              <d-card title="Extras" expand closed>
                <div>
                  <b-row :no-gutters="true">
                    <d-date v-model="g.datafrom" label="From Date"></d-date>
                    <d-date v-model="g.dataval1" label="Not Rec"></d-date>
                    <d-date v-model="g.dataval2" label="Obsolete"></d-date>
                    <d-date v-model="g.datato" label="To Date"></d-date>
                  </b-row>
                  <b-row :no-gutters="true">
                    <d-input v-model="extra_0" label="CModel" type="text" @change="setExtra" />
                    <d-input v-model="extra_1" label="extra_1" type="text" @change="setExtra" />
                    <d-input v-model="extra_2" label="extra_2" type="text" @change="setExtra" />
                    <d-input v-model="extra_3" label="extra_3" type="text" @change="setExtra" />
                  </b-row>
                </div>
              </d-card>
            </b-row>
            <b-row :no-gutters="true" full>
              <d-card title="Price Elements" expand closed>
                <div class="row">
                  <d-input v-model="g.baselist" label="Forced Group/List" type="text" />
                  <d-input v-model="g.coefflist" label="Coeff" type="number" />
                </div>
                <div class="mt-2">
                  <d-label label="Exceptions" />
                  <d-table id="exceptions" label="Exceptions" :rows="g.extlist" :columns="exceptionsfields" editable
                           add
                  ></d-table>
                </div>
              </d-card>
            </b-row>
            <b-row :no-gutters="true" full>
              <d-card title="Exclusions" expand closed>
                <div class="row">
                  <div class="col-6">
                    <b-row :no-gutters="true" full>
                      <d-table id="typology" :rows="g.tipincluded" :columns="exclusionsfields_typology" editable
                               add
                      ></d-table>
                    </b-row>
                  </div>
                  <div class="col-6">
                    <b-row :no-gutters="true" full>
                      <d-table id="productcategory" :rows="g.groupincluded" :columns="exclusionsfields_productcategory"
                               editable add
                      ></d-table>
                    </b-row>
                  </div>
                </div>
              </d-card>
            </b-row>
            <b-row :no-gutters="true" full>
              <d-card title="Commercial limits on variants" expand closed>
                <div>
                  <d-table id="climits" :rows="g.climits" :columns="climitsfields" editable add></d-table>
                </div>
              </d-card>
            </b-row>
            <b-row :no-gutters="true" full>
              <d-card title="Variants" expand closed>
                <d-label label="forced variants" />
                <d-table id="forcedvariants" :rows="g.forcedvariants" :columns="vatiantfields" editable add
                         @addelement="addrow($event)"
                >
                  <template slot="_var" slot-scope="s">
                    <d-coddes v-model="s.data" cod="codvar" des="desvar" small
                              :search="{ service:'cModelsData', params: {Table:'VAR', Catalogo: this.user.catalog || this.user.cats[0].cod}}"
                    />
                  </template>
                  <div slot="_opz" slot-scope="s">
                    <d-coddes v-model="s.data" cod="codopz" des="desopz" small
                              :search="{ service:'cModelsData', params: {Table:'OPZ', Catalogo: this.user.catalog || this.user.cats[0].cod}}"
                    />
                  </div>
                  <div slot="_detail" slot-scope="s">
                    <small>
                      <b-row v-for="(x,k) in g.forcedvariants" :key="k" :no-gutters="true">
                        <d-label :label="coldes(k)" :cols="2" />
                        <d-input v-model="g.forcedvariants[k].codvar" small :cols="10" />
                      </b-row>
                    </small>
                  </div>
                </d-table>
                <d-label label="defaults for model" />
                <d-table id="rows" :rows="g.defaultvariants" :columns="vatiantfields" editable add
                         :details="g.cod!='CMOD'"
                >
                  <div slot="_detail" slot-scope="s">
                  </div>
                </d-table>
              </d-card>
            </b-row>
          </div>
        </div>
      </div>
      <!--<div slot="id1">
        <d-doc :cod="doctables" />
        TODO: Price Element, Exceptions grp coddes (cModelsData,HelperSearch,CFILTER not working on backend (no cFilters
        in _extras/schmidtgroupe.ddb))?
      </div>-->
      <div slot="id1">
        <d-json v-model="g" />
      </div>
    </d-nav>
  </d-pageedit>
</template>
<script>
    import { NextApiClient as Dau } from '@3cad/nextcore'
    export default {
        props: {
            params: String
        },
        data () {
            return {
                detailrow: -1,
                service: 'cModelsData',
                g: {cod: '', cols: [], rows: []},
                colfields: [
                    {id: '', title: 'Related models', w: 5, type: 'coddes', table: 'cModelsData,HelperSearch,CMOD'},
                ],
                vatiantfields: [
                    {id: '_var', title: 'Variant', w: 5},
                    {id: '_opz', title: 'Option', w: 5},
                ],
                climitsfields: [
                    {id: '', title: 'Limit', w: 5, type: 'coddes', table: 'cModelsData,HelperSearch,CLIMITS:G'},
                    {id: 'd1', title: 'From Date', w: 2, type: 'date'},
                    {id: 'd2', title: 'To Date', w: 2, type: 'date'},
                ],
                exceptionsfields: [
                    {id: 'grp', title: 'Grp', w: 5, type: 'coddes', table: 'cModelsData,HelperSearch,CFILTER'},
                    {id: 'perc', title: 'Perc', w: 2},
                    {id: 'cod', title: 'Conditions', w: 3}
                ],
                exclusionsfields_typology: [
                    {id: '', title: 'Typology', w: 5, type: 'coddes', table: 'cModelsData,HelperSearch,TIP'},
                ],
                exclusionsfields_productcategory: [
                    {id: '', title: 'Product Category', w: 5, type: 'coddes', table: 'cModelsData,HelperSearch,CM'},
                ],
                extra_0: '', extra_1: '', extra_2: '', extra_3: '',
            }
        },
        computed: {
            details () {
                var r = []
                if (this.detailrow >= 0 && this.detailrow < this.g.rows.length) {
                    var rr = this.g.rows[this.detailrow]
                    for (var i = 0; i <= rr.cols.length && i < this.g.cols.length; i++) {
                        r.push({id: this.g.cols[i].des, val: rr.cols[i]})
                    }
                }
                return r
            },
            doctables () {
                return 'cmodels'
            },
            newname () {
                return 'C' + this.g.cod
            },
            user () {
                return this.$store.getters['getProfile']
            }
        },
        methods: {
            coldes (k) {
                return this.g.cols && this.g.cols[k] ? this.g.cols[k].cod : k + ''
            },
            coldata (s) {
                if (s.cols.length < this.g.cols.length) {
                    for (var i = s.cols.length; i < this.g.cols.length; i++) s.cols.push('')
                }
                return s.cols
            },
            addelement () {
                this.clear()
                this.searchmode = false
                this.modenew = true
            },
            getsearch () {
                return {
                    service: 'cModelsData',
                    params: {
                        Table: 'CMOD',
                        Catalogo: this.user.catalog || this.user.cats[0].cod
                    }
                }
            },
            clear (e) {
                this.g = {rows: [], cols: []}
            },
            load (e) {
                var sc = this
                Dau.com(sc.service, 'jCmodelsLoad', {
                    Catalogo: e.catalog,
                    Direction: '',
                    cod: e.data.cod || ''
                }, (d) => {
                    sc.g = d
                    sc.modenew = false
                    sc.searchmode = false
                }, err => {
                    throw err;
                })
            },
            save (e) {
                var sc = this
                Dau.com(sc.service, 'jCmodelsSave', {Catalogo: e.catalog || '', data: JSON.stringify(sc.g)}, (d) => {
                    sc.g = d
                    if (e.callback) e.callback(d)
                })
            },
            del (e) {
                var sc = this
                Dau.com(sc.service, 'CmodelsDelete', {Catalogo: e.catalog || '', cod: sc.g.cod}, () => {
                    sc.clear()
                    if (e.callback) e.callback()
                })
            },
            setExtra () {
                this.g.extra = this.extra_0 + '\t' + this.extra_1 + '\t' + this.extra_2 + '\t' + this.extra_3
            },
            add (g) {
                g.push({})
            },
            remove (g, id) {
                g.splice(id, 1)
            },
            changeimg (e) {
                console.log('chageimg', e)
                var x = e + '?' + Date.now()
                this.g.logo = x
            },
            addrow (e) {
                e.codvar = ''
                e.desvar = ''
                e.codopz = ''
                e.desopz = ''
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/erp/pages/base/cmodels.vue